import { gql } from "../gql";

export const APPOINTMENT_SUBSCRIPTION = gql(`
  subscription AppointmentStream($filters: SubscriptionFilterInput!) {
    appointmentStream(filters: $filters) {
      event
      appointment {
        ...AppointmentList @unmask
      }
      salonId
      userId
      timestamp
    }
  }
`);

export const CUSTOMER_SUBSCRIPTION = gql(`
  subscription CustomerUpdated($filters: SubscriptionFilterInput) {
    customerUpdated(filters: $filters) {
      event
      customer {
        id
        firstName
        lastName
        phoneNumbers {
          id
          phone
          isPrimary
          isActive
          label
        }
        primaryPhone {
          id
          phone
          label
        }
        email
        totalPoints
        totalVisits
        currentTier {
          name
          color
        }
      }
      salonId
      userId
    }
  }
`);

export const DASHBOARD_METRICS_SUBSCRIPTION = gql(`
  subscription DashboardMetricsUpdates($salonId: ID!) {
    dashboardMetricsUpdates(salonId: $salonId) {
      event
      dashboardMetrics {
        appointments {
          total
          completed
          confirmed
          pending
          cancelled
        }
        revenue {
          today
          formatted
        }
        workers {
          available
          total
          utilization
        }
        upcoming {
          nextHour
          nextTwoHours
          today
        }
        alerts {
          overbooked
          unassigned
          conflicts
        }
        requests
        tabs {
          today
          incoming
          requests
        }
        lastUpdated
      }
      salonId
      userId
      timestamp
    }
  }
`);

export const AUDIT_SUBSCRIPTION = gql(`
  subscription AuditStream($filters: SubscriptionFilterInput!) {
    auditStream(filters: $filters) {
      event
      auditEntry {
        id
        tableName
        entityId
        operation
        changes {
          field
          oldValue
          newValue
          prismaType
          enumValues
          isRelation
          relatedModel
          fieldKind
        }
        timestamp
        userId
        salonId
        ipAddress
        userAgent
        user {
          id
          firstName
          lastName
          email
          fullName
        }
      }
      salonId
      userId
      timestamp
    }
  }
`);

export const SERVICE_SUBSCRIPTION = gql(`
  subscription ServiceStream($filters: SubscriptionFilterInput!) {
    serviceStream(filters: $filters) {
      event
      service {
        id
        name
        description
        serviceCode
        duration
        pricingMode
        basePrice
        isActive
        allowOnlineBooking
        categoryId
        createdAt
        updatedAt
        category {
          id
          name
          color
        }
        displayPrice {
          mode
          fixedPrice
          priceRange {
            minPrice
            maxPrice
          }
          requiresQuote
        }
        serviceOptionGroups {
          id
          name
          selectionType
          options {
            id
            optionName
            priceModifier
            durationModifier
          }
        }
      }
      salonId
      userId
      timestamp
    }
  }
`);

export const CATEGORY_SUBSCRIPTION = gql(`
  subscription CategoryStream($filters: SubscriptionFilterInput!) {
    categoryStream(filters: $filters) {
      event
      category {
        id
        name
        description
        color
        icon
        sortOrder
        isArchived
        allowOnlineBooking
        createdAt
        updatedAt
      }
      salonId
      userId
      timestamp
    }
  }
`);
